<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini" id="formCalibrationRecordsInline">
               <el-form-item label="运维公司" >
					<el-select v-model="filters.operationcompanyId"  filterable  placeholder="请选择运维公司">
						<el-option
							v-for="item in operationcompanyList" :label="item.name" :value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="主管">
					<el-input v-model="filters.director" placeholder="请输入主管" style="max-width:120px" ></el-input>
				</el-form-item>
                <el-form-item  label="校验">
					<el-input v-model="filters.checks" placeholder="请输入校验" style="max-width:120px" ></el-input>
				</el-form-item>
                <el-form-item  label="校准">
					<el-input v-model="filters.calibration" placeholder="请输入校准" style="max-width:120px" ></el-input>
				</el-form-item>
                 <el-form-item label="校准仪器" >
					<el-select v-model="filters.devicecalibrationid"  filterable  placeholder="请选择校准仪器">
						<el-option
							v-for="item in deviceCailsList" :label="item.meteringutensil" :value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
            	<el-form-item label="时间范围" >
					<el-date-picker
                        v-model="time" type="daterange" :picker-options="pickerOptions" 	value-format="yyyy-MM-dd" 
                        range-separator="-"  start-placeholder="开始日期"  end-placeholder="结束日期"  align="right"  style="max-width:240px" >
                    </el-date-picker>
                </el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow ResetButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="calibrationRecords" highlight-current-row v-loading="listLoading"  style="width: 100%;" border :height="formHeight" size="mini">
			<el-table-column type="index" label="序号">
			</el-table-column>
            <el-table-column prop="devicecalibrationname" label="校准仪器">
			</el-table-column>
            <el-table-column prop="certificateno" label="证书号">
			</el-table-column>
            <el-table-column prop="accuracylevel" label="准确度等级">
			</el-table-column>
            <el-table-column prop="director" label="主管">
			</el-table-column>
              <el-table-column prop="checks" label="校验">
			</el-table-column>
              <el-table-column prop="calibration" label="校准">
			</el-table-column>
			<el-table-column prop="calibrationdate" label="校准日期">
			</el-table-column>
            <el-table-column prop="validuntil" label="有效期至">
			</el-table-column>
            <el-table-column  label="校准证书">
               <template slot-scope="scope">
                    <el-image   style="width: 30px; height: 16px;"  src="/static/query.png"   :preview-src-list="scope.row.calibrationSrcList">  </el-image>
                </template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
					<table-delete-button  @select-type="handleDel(scope.$index, scope.row)"    v-if="usertype==0"></table-delete-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<!--Form界面 角色修改、添加-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false"  top="8vh">
			<el-form :model="formCalibrationRecords" label-width="120px" :rules="formRules" ref="formCalibrationRecords"  :inline="true" id="formCalibrationRecords">
            	<el-form-item label="校准仪器" prop="devicecalibrationid">
					<el-select v-model="formCalibrationRecords.devicecalibrationid"  filterable  placeholder="请选择校准仪器">
                        <el-option
							v-for="item in deviceCailsList" :label="item.meteringutensil" :value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="证书号" prop="certificateno">
					<el-input v-model="formCalibrationRecords.certificateno" ></el-input>
				</el-form-item>
                <el-form-item label="准确度等级" prop="accuracylevel">
					<el-input v-model="formCalibrationRecords.accuracylevel" ></el-input>
				</el-form-item>
                <el-form-item label="主管" prop="director">
					<el-input v-model="formCalibrationRecords.director" ></el-input>
				</el-form-item>
                <el-form-item label="校验" prop="checks">
					<el-input v-model="formCalibrationRecords.checks" ></el-input>
				</el-form-item>
                 <el-form-item label="校准" prop="calibration">
					<el-input v-model="formCalibrationRecords.calibration" ></el-input>
				</el-form-item>
				<el-form-item label="校准日期" prop="calibrationdate">
					<el-date-picker v-model="formCalibrationRecords.calibrationdate" align="right" type="date" format="yyyy-MM-dd"	value-format="yyyy-MM-dd"> </el-date-picker>
				</el-form-item>
                <el-form-item label="有效期至" prop="validuntil">
					<el-date-picker v-model="formCalibrationRecords.validuntil" align="right" type="date" format="yyyy-MM-dd"  	value-format="yyyy-MM-dd"> </el-date-picker>
				</el-form-item>

                <el-form-item label="校准证书图片" prop="calibrationimage" class="calibrationimage">
					<el-upload class="upload-demo" action="#" :http-request="httpRequest" ref="upload" name="file" :on-change="changeCalibration" :on-remove="removeCalibration"
					 accept="image/*"  :file-list="fileListShowCalibration"  list-type="picture" multiple :auto-upload="false" >
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传图片文件，且最好不超过500kb</div>
					</el-upload>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import { getCalibrationRecordsList,deleteCalibrationRecords,updateCalibrationRecords,addCalibrationRecords,getOperationCompanyList,getAllDeviceCailsList } from '../../api/api';
	import {formatDate} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'
	import TableDeleteButton from '../../components/myButton/TableDeleteButton.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'

	export default {
	components: { myButton,TableUpdateButton,TableDeleteButton },
		data() {
			return {
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一天',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                        picker.$emit('pick', [start, end]);
                        }
                    },{
                        text: '最近一周',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                        }
                    }]
                },
				filters: {
                    operationcompanyId:'',
					director: '',
                    checks:'',
                    calibration:'',
                    devicecalibrationid:''
				},
				time:[],
				calibrationRecords: [ ],
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				type:'新增',

				formVisible: false,//修改界面是否显示
				loading: false,
				formRules: {
					certificateno: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    accuracylevel: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    director: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    checks: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    calibration: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    calibrationdate: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    validuntil: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
					devicecalibrationid: [
						{ required: true, message: '必选', trigger: 'change' }
					],
					calibrationimage: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
				},
				//修改界面数据
				formCalibrationRecords: {},
				formHeight:0,
                operationcompanyList:[],
                deviceCailsList:[],
				fileListCalibration: [],
				fileListShowCalibration:[],
				removeFileIdCalibration:[],
				lengthCalibration:0,
				usertype:sessionStorage.getItem("type"),
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getCalibrationRecords();
				}else if(type=="add"){
					this.handleAdd();
				}else if(type=="reset"){
					this.reset();
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getCalibrationRecords();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getCalibrationRecords();
			},
            reset(){
                this.filters={
                    operationcompanyId:'',
					director: '',
                    checks:'',
                    calibration:'',
                    devicecalibrationid:'',
                };
				this.time=[];
            },
            getOperationCompanyList(){
                if(this.operationcompanyList.length>0){
                    return;
                }
				getOperationCompanyList({}).then((res) => {
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					this.operationcompanyList = res.data.data;
				});
            },
            getAllDeviceCailsList(){
                if(this.deviceCailsList.length>0){
                    return;
                }
				getAllDeviceCailsList({}).then((res) => {
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					this.deviceCailsList = res.data.data;
				});
            },
			//获取用户列表
			getCalibrationRecords() {
                let para = Object.assign({}, this.filters);
                para.page= this.page;
                para.pageSize=this.pageSize;

                var starttime='';
                var endtime='';
                if(this.time!=null&&this.time.length>0){
                    starttime=this.time[0];
					endtime=this.time[1];
                }
                para.starttime=starttime;
                para.endtime=endtime;

				this.listLoading = true;
				getCalibrationRecordsList(para).then((res) => {
					this.listLoading = false;
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					 this.total = res.data.total;
					 this.calibrationRecords = res.data.data;
                     this.calibrationRecords.forEach(element => {
                        var arr=[];
                        var imgarr=element.calibrationimage.split(';');
                        for(var j=0;j<imgarr.length;j++){
                            if(imgarr[j]==""){
                                continue;
                            }
                            var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
                            arr.push(url);
                        }
                        element.calibrationSrcList=arr;
					});
				});
			},
			httpRequest(){},
			removeCalibration:function(file, fileList){
				if(file.name==undefined){
					var i=0;
					this.fileListCalibration.forEach(element => {
						if(element.uid==file.uid){
							this.fileListCalibration.splice(i, 1);
							return;
						}
						i++;
					});
				}else{
					this.removeFileIdCalibration.push(file.name);
				}
			},
			changeCalibration:function(file, fileList){
				//判断上传文件数量
				this.lengthCalibration=document.querySelector("input[type=file]").files.length;

				if(this.lengthCalibration>0){
					Array.from(document.querySelector("input[type=file]").files).forEach(file=>{
						if(this.fileListCalibration.indexOf(file) == -1){
							this.fileListCalibration.push(file);
						}
					})
				}
				return false;
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该条记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.loading = true;
					let param = new URLSearchParams()
					param.append('id', row.id)
					deleteCalibrationRecords(param).then((res) => {
						this.loading = false;
                        if(res.data.result=="false"){
                            this.$message({
                                message: "操作失败，请重试",
                                type: 'error'
                            })
                        }else{
                            this.$message({ 
								message: '操作成功',
								type: 'success'
							});
                        }
						this.getCalibrationRecords();
					});
				}).catch(() => {

				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
				this.removeFileIdCalibration=[];
				this.fileListCalibration=[];
				this.formVisible = true;
				if( this.$refs.formCalibrationRecords!=undefined){
               		this.$refs.formCalibrationRecords.resetFields();
				}
				this.type='修改';

				this.fileListShowCalibration=[];
				var imgarr=row.calibrationimage.split(';');
				for(var j=0;j<imgarr.length;j++){
					if(imgarr[j]==""){
						continue;
					}
					var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
					var obj={
						url:url,
						name:imgarr[j]
					}
					this.fileListShowCalibration.push(obj);
				}
				this.formCalibrationRecords = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
				this.fileListShowCalibration=[];
                this.removeFileIdCalibration=[];
				this.fileListCalibration=[];
				this.formVisible = true;
				if( this.$refs.formCalibrationRecords!=undefined){
               		this.$refs.formCalibrationRecords.resetFields();
				}
				this.type='新增';
				
				this.formCalibrationRecords = {
					calibrationimage: '11',
				}
			},
			//Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
					this.addSubmit();
                }
            },
			//修改
			editSubmit: function () {
				this.$refs.formCalibrationRecords.validate((valid) => {
					if (valid) {
                        if(this.fileListCalibration.length+this.formCalibrationRecords.calibrationSrcList.length<=this.removeFileIdCalibration.length){
							this.$message({
								message: "请上传校准证书图片再提交",
								type: 'error'
							})
							return;
						}
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							let formData = new FormData();
                            var j=0;
							this.fileListCalibration.forEach(file=> {
								formData.append("fileListCalibration"+j, file);
								j++;
							});

                            formData.append("removeFileIdCalibration",this.removeFileIdCalibration.toString());

							formData.append("id",this.formCalibrationRecords.id);
							formData.append("devicecalibrationid",this.formCalibrationRecords.devicecalibrationid);
                            formData.append("certificateno",this.formCalibrationRecords.certificateno);
                            formData.append("accuracylevel",this.formCalibrationRecords.accuracylevel);
                            formData.append("director",this.formCalibrationRecords.director);
                            formData.append("checks",this.formCalibrationRecords.checks);
                            formData.append("calibration",this.formCalibrationRecords.calibration);
                            formData.append("calibrationdate",this.formCalibrationRecords.calibrationdate);
                            formData.append("validuntil",this.formCalibrationRecords.validuntil);
							formData.append("calibrationimage",this.formCalibrationRecords.calibrationimage);

							updateCalibrationRecords(formData).then((res) => {
								this.loading = false;
								if(res.data.result=="false"){
									this.$message({
										message: "数据操作失败，请重试",
										type: 'error'
									})
									return;
								}
								this.$message({
									message: '操作成功',
									type: 'success'
								});
                                this.fileListShowCalibration=[];
                                this.removeFileIdCalibration=[];
								this.formVisible = false;
								this.getCalibrationRecords();
							}).catch(error => {
								this.loading = false;
								this.$message({
									message: "数据操作失败，可能是文件过大",
									type: 'error'
								})
								return;
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.formCalibrationRecords.validate((valid) => {
					if (valid) {
                        if(this.fileListCalibration.length==0){
							this.$message({
								message: "请上传校准证书图片再提交",
								type: 'error'
							})
							return;
						}
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							let formData = new FormData();
                            var j=0;
							this.fileListCalibration.forEach(file=> {
								formData.append("fileListCalibration"+j, file);
								j++;
							});
							formData.append("fileListCalibrationLen",j);

                            formData.append("devicecalibrationid",this.formCalibrationRecords.devicecalibrationid);
                            formData.append("certificateno",this.formCalibrationRecords.certificateno);
                            formData.append("accuracylevel",this.formCalibrationRecords.accuracylevel);
                            formData.append("director",this.formCalibrationRecords.director);
                            formData.append("checks",this.formCalibrationRecords.checks);
                            formData.append("calibration",this.formCalibrationRecords.calibration);
                            formData.append("calibrationdate",this.formCalibrationRecords.calibrationdate);
                            formData.append("validuntil",this.formCalibrationRecords.validuntil);

							this.loading = true;
							addCalibrationRecords(formData).then((res) => {
								this.loading = false;
								if(res.data.result=="false"){
									this.$message({
										message: "数据操作失败，请重试",
										type: 'error'
									})
									return;
								}
								this.$message({
									message: '操作成功',
									type: 'success'
								});
                                this.fileListShowCalibration=[];
                                this.removeFileIdCalibration=[];
								this.formVisible = false;
								this.getCalibrationRecords();
							}).catch(error => {
								this.loading = false;
								this.$message({
									message: "数据操作失败，可能是文件过大",
									type: 'error'
								})
								return;
							});
						});
					}
				});
			},
			//取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-100;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getCalibrationRecords();
            this.getAllDeviceCailsList();
            this.getOperationCompanyList();
		}
	}

</script>

<style scoped>
	.containerDeviceCails{
		display: flex;
	}
	.containerDeviceCails .block {
		-ms-flex: 1;
		flex: 1;
		padding: 0 24px;
	}
	.containerDeviceCails .title{
		font-weight: bold;
		margin-bottom: 10px;
	}
    #formCalibrationRecords .el-form-item{
        width: 45%;
    }
</style>

<style>
	#formCalibrationRecords .calibrationimage{
		width: 100%!important;
	}
	#formCalibrationRecords .calibrationimage .el-form-item__content{
		width:80%;
	}
	#formCalibrationRecords .el-form-item__content{
		width: calc(100% - 150px) ;
	}

	#formCalibrationRecordsInline{
		padding: 0;
	}
</style>


// WEBPACK FOOTER //
// CalibrationRecord.vue?c7235244